<template>
  <v-card class="mt-2">
    <v-card-title>
      <span class="headline"> {{ $t("reservations.client.details") }} </span>
    </v-card-title>
    <v-card-text>
      <v-row class="justify-center text-center">
        <!--SELECT CLIENT-->
        <v-col xs="6" sm="8" md="9">
          <v-autocomplete
            v-model="client"
            :items="clients"
            :loading="loading"
            :label="$t('reservations.client.select_client')"
            :rules="rules.requiredSelect"
            color="red-darken-1"
            item-title="name"
            item-value="_id"
            prepend-icon="person"
            return-object
          >
            <template #selection="data">
              <span v-if="data && data.item">
                {{ data.item.name }} {{ data.item.surname }}
              </span>
              <span v-else />
            </template>
            <template #item="data">
              <span v-if="data && data.item">
                {{ data.item.name }} {{ data.item.surname }}
              </span>
              <span v-else />
            </template>
          </v-autocomplete>
        </v-col>
        <!--ADD CLIENT-->
        <v-col xs="6" sm="4" md="3">
          <v-btn
            color="success"
            class="mt-4"
            depressed
            small
            @click="addClient"
          >
            {{ $t("reservations.client.new_client") }}
          </v-btn>
        </v-col>
        <!--COMMENT-->
        <v-col xs="12" md="12" lg="12">
          <v-textarea
            v-model="comment"
            :label="$t('reservations.client.comment')"
            color="red-darken-2"
          />
        </v-col>
        <!--PRICE-->
        <v-col xs="6" pr-2>
          <v-text-field
            v-model="calculatedPrice"
            disabled
            :label="$t('reservations.client.calculated_price')"
            color="red-darken-2"
          />
        </v-col>
        <v-col xs="6" pl-2>
          <v-row row wrap>
            <v-col xs="6" pr-1>
              <v-text-field
                v-model="proposedPrice"
                type="number"
                min="0"
                :label="$t('reservations.client.proposed_price')"
                color="red-darken-2"
              />
            </v-col>
            <v-col xs="6" pl-1>
              <v-select
                v-model="currency"
                :items="currencyItems"
                :label="$t('reservations.client.currency')"
                color="red-darken-2"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import getRequest from "../../../api/getRequest";

export default {
  props: {
    price: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    loading: false,
    client: {},
    clients: [],
    rules: { requiredSelect: [(v) => (v && !!v.name) || "Item is required"] },
    comment: "",
    proposedPrice: 0,
    currency: "EUR",
    currencyItems: ["EUR"], // 'ALL',
  }),
  computed: {
    calculatedPrice() {
      return this.$props.price;
    },
  },
  mounted() {
    this.getClients();
  },
  methods: {
    addClient() {
      this.$emit("add-client");
    },
    getClients() {
      this.loading = true;
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.clients = response.clients;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
